var map = {
	"./Allahabad_Bank_Logo.png": 83759,
	"./AmEx.png": 1145,
	"./American express.png": 48038,
	"./Andhra bank.png": 73394,
	"./Any.png": 45772,
	"./BOA-1.png": 68146,
	"./Bank of Bahrain and Kuwait.png": 16164,
	"./Bank_default.png": 58436,
	"./Bassien Catholic Co-Operative Bank.png": 95988,
	"./Bharatiya Mahila Bank.png": 13893,
	"./Corporation Bank.png": 8880,
	"./Cosmos co-operative bank.png": 83368,
	"./Credit Suisse Ag.png": 50851,
	"./DBS Bank.png": 62569,
	"./DCB bank.png": 88983,
	"./Default Card.png": 26843,
	"./Dena Bank.png": 82158,
	"./Dhanlakshmi Bank.png": 56306,
	"./Diners.png": 48135,
	"./Equitas small finance bank.png": 20551,
	"./FEDRAL.png": 61362,
	"./Fincare Bank.png": 49210,
	"./HSBC.png": 65314,
	"./Hongkong and Shanghai Banking Corporation.png": 3911,
	"./IDBI first.png": 86162,
	"./IDBI.png": 94932,
	"./IDFC.png": 54938,
	"./Instant Pay.png": 67435,
	"./InstantPay.png": 55751,
	"./JCB.png": 60243,
	"./Janata Sahakari Bank Ltd Pune.png": 60683,
	"./KJSB.png": 19904,
	"./KalupurCommercial.png": 8754,
	"./Kanara District Central Co-operative Bank.png": 14151,
	"./Karnataka Gramin Bank.png": 12092,
	"./Karnataka.png": 67298,
	"./Lakshmi Vilas Bank.png": 1664,
	"./MC.png": 26136,
	"./Master card.png": 23834,
	"./Mastercard.png": 3124,
	"./Mehsana urban Co-op Bank.png": 86139,
	"./National Co-operative Bank.png": 58370,
	"./Oriental Bank of Commerce.png": 69156,
	"./Ratnakar Corporate Banking.png": 53943,
	"./Reserve Bank of India.png": 57974,
	"./Royal Bank Of Scotland.png": 44552,
	"./RoyalBank.png": 21897,
	"./RuPay.png": 26809,
	"./SBBJ.png": 41799,
	"./SBH.png": 30003,
	"./SBM.png": 45134,
	"./SBP.png": 84667,
	"./Shivalik.png": 37791,
	"./Standard Charted.png": 232,
	"./Standard Chartered.png": 31169,
	"./State Bank of Bikaner and Jaipur.png": 97452,
	"./State Bank of Hyderabad.png": 47564,
	"./State Bank of Mysore.png": 67473,
	"./State Bank of Patiala.png": 71236,
	"./Status - pending.png": 11930,
	"./SuratPeople.png": 16602,
	"./TNSbank.png": 21485,
	"./Tamil Nadu State Co-operative Bank.png": 55166,
	"./Tamilnad Mercantile Bank Ltd.png": 54134,
	"./The Kalupur Commercial Cooperative Bank Limited.png": 47000,
	"./The Surat People’s Co-operative Bank Limited.png": 88639,
	"./Types/Maintenance.png": 14729,
	"./Types/Primary.png": 73374,
	"./UPI.png": 70690,
	"./United Bank of India.png": 18337,
	"./UnitedBankofIndia.png": 79003,
	"./Utkarshinance.png": 19484,
	"./Vijaya Bank.png": 96166,
	"./VijayaBank.png": 1428,
	"./Visa.png": 96179,
	"./au small finance bank.png": 56527,
	"./axis.png": 3559,
	"./bandhan.png": 44236,
	"./bank-of-baroda.png": 5302,
	"./bank-of-india.png": 24144,
	"./bank-of-maharashtra.png": 13465,
	"./barclays.png": 56847,
	"./bharat cooperative bank.png": 84155,
	"./canara-bank.png": 35845,
	"./central-bank-of-india.png": 45560,
	"./citi-bank.png": 32742,
	"./csk-bank.png": 46556,
	"./cub.png": 28900,
	"./dcb.png": 87889,
	"./deutsche.png": 70181,
	"./dhanlaxmi bank.png": 53352,
	"./emirates.png": 73984,
	"./gujarat state co-operative bank.png": 80777,
	"./hdfcbank.png": 47399,
	"./icici.png": 67407,
	"./indian overseas bank.png": 14637,
	"./indian-bank.png": 95170,
	"./indusland.png": 46486,
	"./jk-bank.png": 8990,
	"./jp-morgan-chase.png": 13464,
	"./kotak.png": 71384,
	"./kvb - 1.png": 40649,
	"./nkgsb-bank – 1.png": 82992,
	"./nkgsb-bank.png": 20874,
	"./pmc bank.png": 91990,
	"./pnb.png": 21450,
	"./punjab-sind-bank.png": 21414,
	"./rbl.png": 5298,
	"./saraswat co-operative bank.png": 90866,
	"./sbi.png": 92682,
	"./shivalik bank.png": 40293,
	"./south-indian-bank.png": 62162,
	"./svc bank.png": 2036,
	"./syndicate bank.png": 33820,
	"./thane Janata sahakari bank.png": 27239,
	"./the surat people’s co-operative bank.png": 23829,
	"./uco.png": 23541,
	"./union-bank.png": 37152,
	"./utkarsh small finance bank.png": 20009,
	"./yes-bank.png": 23580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48575;